<div *ngIf="formStatus !== FormStatus.COMPLETE">
  <div class="mr-small-b pr-medium-t font-body-1">
    <button class="no-decoration nordic-blue-900-text font-body-1 medium-type" (click)="backToPreviousPage()">
      <fcom-icon class="back-link-icon nordic-blue-900-text icon-small" [name]="SvgLibraryIcon.ARROW_LEFT"></fcom-icon>
      {{ 'actions.back' | finLocalization }}
    </button>
  </div>

  <div>
    <h1 class="nordic-blue-900-text mr-small-b ms-clear-t font-heading-2">
      {{ 'SERVICE_FORMS.CSServiceForms.retrieveFeedback.page.title' | finLocalization }}
    </h1>
  </div>

  <div class="fill grid-col grid-col-12 no-gutters">
    <div class="rounded-large white-bg pr-small border col-1-12 md-col-1-8 mr-medium-b">
      <form
        class="service-form retrieve-form"
        [formGroup]="form"
        (ngSubmit)="retrieveCase()"
        *ngIf="
          formStatus === FormStatus.INITIAL ||
          formStatus === FormStatus.ERROR ||
          formStatus === FormStatus.REFUND_CASE_NOT_SUPPORTED
        "
        data-testid="retrieve-form"
        [finFormErrorFocus]="form"
      >
        <fcom-notification
          *ngIf="formStatus === FormStatus.ERROR"
          class="mr-medium-b"
          role="alert"
          [layout]="NotificationLayout.BLOCK"
          [theme]="NotificationTheme.ALERT"
        >
          {{ 'SERVICE_FORMS.CSServiceForms.retrieveFeedback.page.notification' | finLocalization }}
        </fcom-notification>

        <fcom-notification
          *ngIf="formStatus === FormStatus.REFUND_CASE_NOT_SUPPORTED"
          class="mr-medium-b"
          role="alert"
          [layout]="NotificationLayout.BLOCK"
          [theme]="NotificationTheme.ALERT"
        >
          <span
            [innerHTML]="
              'SERVICE_FORMS.CSServiceForms.retrieveFeedback.page.refundCaseNotSupportedNotification' | finLocalization
            "
          ></span>
        </fcom-notification>

        <fcom-text-input
          [parentForm]="group"
          [controlName]="RetrieveFields.FAMILY_NAME"
          [placeHolder]="'SERVICE_FORMS.CSServiceForms.wizard.steps.addPassenger.passenger.lastName.placeholder'"
          [translationPrefix]="'SERVICE_FORMS.CSServiceForms.wizard.steps.addPassenger.passenger.lastName'"
          [attr.data-testid]="'retrieve-' + RetrieveFields.FAMILY_NAME"
        ></fcom-text-input>
        <fcom-text-input
          [parentForm]="group"
          [controlName]="RetrieveFields.CASE_NUMBER"
          [placeHolder]="'SERVICE_FORMS.CSServiceForms.retrieveFeedback.caseNumber.placeholder'"
          [translationPrefix]="'SERVICE_FORMS.CSServiceForms.retrieveFeedback.caseNumber'"
          [attr.data-testid]="'retrieve-' + RetrieveFields.CASE_NUMBER"
        ></fcom-text-input>
        <div class="ps-small-t grid-col grid-col-12 no-gutters">
          <fcom-button
            class="submit-data col-1-5"
            [mode]="ButtonMode.FILL"
            [type]="ButtonType.SUBMIT"
            [text]="'SERVICE_FORMS.CSServiceForms.wizard.continue' | finLocalization"
            data-testid="retrieve-submit-button"
          ></fcom-button>
        </div>
      </form>

      <fin-loader
        class="relative loader"
        role="status"
        *ngIf="formStatus === FormStatus.LOADING"
        [type]="LoaderType.EMBEDDED"
        [title]="'SERVICE_FORMS.CSServiceForms.retrieveFeedback.page.loading'"
      ></fin-loader>
    </div>
  </div>

  <div *ngIf="additionalInfoTitle" class="nordic-blue-900-text font-body-1 mr-xxsmall-b additional-info-title">
    {{ additionalInfoTitle }}
  </div>
  <div
    *ngIf="additionalInfoText"
    [innerHTML]="additionalInfoText | finSafe: 'html'"
    class="font-body-1 mr-xsmall-b additional-info-text"
  ></div>
</div>

<div *ngIf="formStatus === FormStatus.COMPLETE">
  <div class="mr-medium-b pr-small-t font-body-1">
    <button class="no-decoration nordic-blue-900-text medium-type" (click)="backToForm()">
      <fcom-icon class="back-link-icon nordic-blue-900-text icon-small" [name]="SvgLibraryIcon.ARROW_LEFT"></fcom-icon>
      {{ 'actions.back' | finLocalization }}
    </button>
  </div>

  <fin-retrieve-case [responseContent]="responseContent"></fin-retrieve-case>
</div>
